"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const Loader_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/UI/Loader.vue"));
const randomkey_1 = __importDefault(require("@common/tsutils/randomkey"));
const vue_fullscreen_1 = require("vue-fullscreen");
let BaseMap = class BaseMap extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.mapDivId = (0, randomkey_1.default)('the_map');
    }
    mounted() {
        this.connector.setDivId(this.mapDivId);
        this.connector.randomizeMarkerPosition(false);
    }
    async toggleFullScreen() {
        // @ts-ignore
        const fsMap = this.$refs.fullscreenMap;
        if (this.fullscreen) {
            await fsMap.request();
        }
        else {
            await fsMap.exit();
        }
    }
    onFullscreenChange(fullscreen) {
        this.$emit('fullscreen', fullscreen);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], BaseMap.prototype, "fullscreen", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], BaseMap.prototype, "connector", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('fullscreen')
], BaseMap.prototype, "toggleFullScreen", null);
BaseMap = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Loader: Loader_vue_1.default,
            VueFullscreen: vue_fullscreen_1.component,
        },
    })
], BaseMap);
exports.default = BaseMap;
